import HoverPrefetchLink from '@/components/hover-prefetch-link';
import { cn } from '@/lib/utils';
import clsx from 'clsx';

const CategoryFilterItem = ({
  label,
  href = '#',
  count,
  isActive,
  className,
  mode,
  onClick,
}: {
  label: string;
  href?: string;
  count: number;
  isActive: boolean;
  className?: string;
  mode?: 'link';
  onClick?: () => void;
}) => {
  if (mode === 'link') {
    return (
      <HoverPrefetchLink
        className={cn(
          'group flex items-center gap-x-2.5 text-sm leading-5 decoration-80583F lg_hover_underline',
          className,
        )}
        href={href}
        onClick={() => {
          onClick?.();
        }}
      >
        <span
          className={clsx(
            'h-5 w-5 border-1 border-solid border-80583F',
            isActive && 'bg-80583F',
            'flex items-center justify-center',
            'flex-none',
          )}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='12'
            fill='none'
            viewBox='0 0 14 12'
            className={clsx(!isActive && 'opacity-0')}
          >
            <path
              stroke='#fff'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1.5'
              d='M13 1 4.6 11 1 7.25'
            />
          </svg>
        </span>
        <span className='text-sm lg_text-[15px] lg_group-hover_text-80583F'>
          {label} {count ? `(${count})` : null}
        </span>
      </HoverPrefetchLink>
    );
  }

  return (
    <div
      className={cn(
        'group flex items-center gap-x-2.5 text-sm leading-5 decoration-80583F lg_hover_underline',
        className,
      )}
      onClick={() => {
        onClick?.();
      }}
    >
      <span
        className={clsx(
          'h-5 w-5 border-1 border-solid border-80583F',
          isActive && 'bg-80583F',
          'flex items-center justify-center',
          'flex-none',
        )}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='14'
          height='12'
          fill='none'
          viewBox='0 0 14 12'
          className={clsx(!isActive && 'opacity-0')}
        >
          <path
            stroke='#fff'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M13 1 4.6 11 1 7.25'
          />
        </svg>
      </span>
      <span className='text-sm lg_text-[15px] lg_group-hover_text-80583F'>
        {label} {count ? `(${count})` : null}
      </span>
    </div>
  );
};

export default CategoryFilterItem;
